import { render, staticRenderFns } from "./subject-table.vue?vue&type=template&id=3f915f74&scoped=true"
import script from "./subject-table.vue?vue&type=script&lang=js"
export * from "./subject-table.vue?vue&type=script&lang=js"
import style0 from "./subject-table.vue?vue&type=style&index=0&id=3f915f74&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f915f74",
  null
  
)

export default component.exports